<template>
	<div class="fileSet componetself" v-loading="pageLoad" >
		<div class="formtitle">
			EDI
		</div>
		<!-- 存储地址的配置 -->
		<div class="componet_header">
			<div class="filter">
				<template v-for="(item,index) in  EDI">
					<div class="filter_item" :key="index">
						<c-filter :item="item" 
							:form="filterForm" :line="true" :textMini="90" :IsForm="true"></c-filter>
					</div>
				</template>
			</div>
		</div>
		<div class="formtitle">
			ASN
		</div>
		<div class="componet_header">
			<div class="filter">
				<template v-for="(item,index) in  ASN">
					<div class="filter_item" :key="index">
						<c-filter :item="item" 
							:form="filterForm" :line="true" :textMini="90" :IsForm="true"></c-filter>
					</div>
				</template>
			</div>
		</div>
		<div class="componet_header">
			<el-button type="primary" class="pursh_mainBtn" :loading="saveLoad" :disabled="saveLoad" @click="SAVESET">保存</el-button>
		</div>
		<div class="tip">
			请填写服务器上已经创建的文件夹
		</div>
	</div>
</template>

<script>
	import {fileSet,ASNfiletSet} from './filesetItem.js'
	export default{
		data(){
			return{
				filterForm:{},
				pageLoad:false,
				saveLoad:false
			}
		},
		computed:{
			EDI(){
				return fileSet;
			},
			ASN(){
				return ASNfiletSet;
			},
			filterList(){
				return fileSet.concat(ASNfiletSet);
			},
			userinfo() {
				return this.$store.getters.UserInfo;
			}
		},
		methods:{
			GETSYS(){
				try{
					if(this.pageLoad) return;
					this.pageLoad=true;
					this.$BH().base.http({
						url:'Web/SYSGET',
						success:(res)=>{
							let {value}=res.data;
							(value||[]).map(item=>{
								this.filterForm[item['FNUMBER']]=item['FVALUE'];
							});
							this.filterForm['KEY_TIMEINTERVAL']= Number(this.filterForm['KEY_TIMEINTERVAL']) *1000/1000000;
							console.log(this.filterForm)
							this.filterForm=JSON.parse(JSON.stringify(this.filterForm));
						},
						loadingcontrol:()=>{
							this.pageLoad=false;
						}
					})
				}catch(e){
					//TODO handle the exception
					this.$BH().message(e);
					this.pageLoad=false;
				}
			},
			SAVESET(){
				try{
					if(this.saveLoad) return;
					this.saveLoad=true;
					//校验数据不能为空
					let filterFormTemp=JSON.parse(JSON.stringify(this.filterForm));
					let filterList=JSON.parse(JSON.stringify(this.filterList));
					
					for(let i in this.filterList){
						let name=this.filterList[i]['name'];
						if(!filterFormTemp[name])
							throw `请重新维护${this.filterList[i]['Display']}字段`;
						if(name=='KEY_TIMEINTERVAL')
							filterFormTemp[name]=filterFormTemp[name]*1000;
						filterList[i]['type']=2;
					}
					this.$BH().base.http({
						url:'Web/SYSFSET',
						data:{
							filterList:filterList,
							filterform:filterFormTemp,
							FUSER:this.userinfo.fnumber
						},
						success:(res)=>{
							this.$BH().message(res.data.value)
						},
						loadingcontrol:()=>{
							this.saveLoad=false;
						}
					})
				}catch(e){
					//TODO handle the exception
					this.$BH().message(e);
					this.saveLoad=false;
				}
			}
		},
		created() {
			this.GETSYS()
		}
	}
</script>

<style>
</style>